// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Clickable_clickable__1Vz4v","cursor":"Clickable_cursor__2WA-5","space":"Clickable_space__YnNTk"};